import apiInvent from "../api/inventtypes";
import apiRoom from "../api/roomtypes";
import notify from "devextreme/ui/notify";
import {getResourceTypes, getRoomTypes} from "./actions";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалсоь выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  const CREATE_RESOURCE_TYPE_REQUEST = "CREATE_RESOURCE_TYPE_REQUEST";
  const CREATE_RESOURCE_TYPE_COMPLETED = "CREATE_RESOURCE_TYPE_COMPLETED";
  const CREATE_RESOURCE_TYPE_ERROR = "CREATE_RESOURCE_TYPE_ERROR";

  const CREATE_ROOM_TYPE_REQUEST = "CREATE_ROOM_TYPE_REQUEST";
  const CREATE_ROOM_TYPE_COMPLETED = "CREATE_ROOM_TYPE_COMPLETED";
  const CREATE_ROOM_TYPE_ERROR = "CREATE_ROOM_TYPE_ERROR";

  const UPDATE_RESOURCE_TYPE_REQUEST = "UPDATE_RESOURCE_TYPE_REQUEST";
  const UPDATE_RESOURCE_TYPE_COMPLETED = "UPDATE_RESOURCE_TYPE_COMPLETED";
  const UPDATE_RESOURCE_TYPE_ERROR = "UPDATE_RESOURCE_TYPE_ERROR";

  const UPDATE_ROOM_TYPE_REQUEST = "UPDATE_ROOM_TYPE_REQUEST";
  const UPDATE_ROOM_TYPE_COMPLETED = "UPDATE_ROOM_TYPE_COMPLETED";
  const UPDATE_ROOM_TYPE_ERROR = "UPDATE_ROOM_TYPE_ERROR";

  function createResourceTypeRequest() {
    return {
      type: CREATE_RESOURCE_TYPE_REQUEST,
      isCreatingResType: true
    };
  }

  function createResourceTypeCompleted(createdResType) {
    return {
      type: CREATE_RESOURCE_TYPE_COMPLETED,
      isCreatingResType: false,
      createdResType
    };
  }

  function createResourceTypeError(restypeCreationError) {
    return {
      type: CREATE_RESOURCE_TYPE_ERROR,
      isCreatingResType: false,
      restypeCreationError
    };
  }

  function createRoomTypeRequest() {
    return {
      type: CREATE_ROOM_TYPE_REQUEST,
      isCreatingRoomType: true
    };
  }

  function createRoomTypeCompleted(createdRoomType) {
    return {
      type: CREATE_ROOM_TYPE_COMPLETED,
      isCreatingRoomType: false,
      createdRoomType
    };
  }

  function createRoomTypeError(roomtypeCreationError) {
    return {
      type: CREATE_ROOM_TYPE_ERROR,
      isCreatingRoomType: false,
      roomtypeCreationError
    };
  }

  function updateResourceTypeRequest() {
    return {
      type: UPDATE_RESOURCE_TYPE_REQUEST,
      isUpdatingResType: true
    };
  }

  function updateResourceTypeCompleted(updatedResType) {
    return {
      type: UPDATE_RESOURCE_TYPE_COMPLETED,
      isUpdatingResType: false,
      updatedResType
    };
  }

  function updateResourceTypeError(restypeUpdateError) {
    return {
      type: UPDATE_RESOURCE_TYPE_ERROR,
      isUpdatingResType: false,
      restypeUpdateError
    };
  }

  function updateRoomTypeRequest() {
    return {
      type: UPDATE_ROOM_TYPE_REQUEST,
      isUpdatingRoomType: true
    };
  }

  function updateRoomTypeCompleted(updatedRoomType) {
    return {
      type: UPDATE_ROOM_TYPE_COMPLETED,
      isUpdatingRoomType: false,
      updatedRoomType
    };
  }

  function updateRoomTypeError(roomtypeUpdateError) {
    return {
      type: UPDATE_ROOM_TYPE_ERROR,
      isUpdatingRoomType: false,
      roomtypeUpdateError
    };
  }

  export function createResourceType(data) {
    return dispatch => {
      dispatch(createResourceTypeRequest());
      return apiInvent
        .createInventType(data)
        .then(response => {
          if (response.status === 200) {
            dispatch(createResourceTypeCompleted(response.data));
            dispatch(getResourceTypes());
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(createResourceTypeError(message));
          } else {
            logError(err);
            dispatch(createResourceTypeError(createError("Не удалось отправить запрос добавления типа ресурса")));
          }
        });
    };
  }

  export function createRoomType(data) {
    return dispatch => {
      dispatch(createRoomTypeRequest());
      return apiRoom
        .createRoomType(data)
        .then(response => {
          if (response.status === 200) {
            dispatch(createRoomTypeCompleted(response.data));
            dispatch(getRoomTypes());
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(createRoomTypeError(message));
          } else {
            logError(err);
            dispatch(createRoomTypeError(createError("Не удалось отправить запрос добавления типа помещения")));
          }
        });
    };
  }

  export function updateResourceType(id, data) {
    return (dispatch, getState) => {
      dispatch(updateResourceTypeRequest());
      return apiInvent
        .updateInventType(id, data)
        .then(response => {
          if (response.status === 200) {
            logSuccess("Успешно обновлено");
            dispatch(updateResourceTypeCompleted(response.data));
            dispatch(getResourceTypes());
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }

            logError(message);
            dispatch(updateResourceTypeError(message));
          } else {
            logError(err);
            dispatch(updateResourceTypeError(createError("Не удалось отправить запрос на обновление данных")));
          }
        });
    };
  }

  export function updateRoomType(id, data) {
    return (dispatch, getState) => {
      dispatch(updateRoomTypeRequest());
      return apiRoom
        .updateRoomType(id, data)
        .then(response => {
          if (response.status === 200) {
            logSuccess("Успешно обновлено");
            dispatch(updateRoomTypeCompleted(response.data));
            dispatch(getRoomTypes());
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }

            logError(message);
            dispatch(updateRoomTypeError(message));
          } else {
            logError(err);
            dispatch(updateRoomTypeError(createError("Не удалось отправить запрос на обновление данных")));
          }
        });
    };
  }

  export default {
    CREATE_RESOURCE_TYPE_REQUEST,
    CREATE_RESOURCE_TYPE_COMPLETED,
    CREATE_RESOURCE_TYPE_ERROR,
    CREATE_ROOM_TYPE_REQUEST,
    CREATE_ROOM_TYPE_COMPLETED,
    CREATE_ROOM_TYPE_ERROR,
    UPDATE_RESOURCE_TYPE_REQUEST,
    UPDATE_RESOURCE_TYPE_COMPLETED,
    UPDATE_RESOURCE_TYPE_ERROR,
    UPDATE_ROOM_TYPE_REQUEST,
    UPDATE_ROOM_TYPE_COMPLETED,
    UPDATE_ROOM_TYPE_ERROR,

    createResourceType,
    createRoomType,
    updateResourceType,
    updateRoomType
  }
